/* eslint-disable import/no-cycle */
import api from '@/plugins/axios';
import { mountUrl } from './helper';

const BASE_PATH = 'task';

export default {
  async getById(taskId) {
    const url = mountUrl(`/${BASE_PATH}/${taskId}/get`);
    return api.get(url);
  },
  async getAll(serviceOrderId) {
    const url = mountUrl(`/${BASE_PATH}/${serviceOrderId}/get-all`);
    return api.get(url);
  },
  async create(serviceOrderId, data) {
    const url = mountUrl(`/${BASE_PATH}/${serviceOrderId}/create`);
    return api.post(url, data);
  },
  async updateTask(taskId, data) {
    const url = mountUrl(`/${BASE_PATH}/${taskId}/update`);
    return api.patch(url, data);
  },
  async delete(taskId) {
    const url = mountUrl(`/${BASE_PATH}/${taskId}/delete`);
    return api.delete(url);
  },
  async createTaskInterval(taskId, data) {
    const url = mountUrl(`/${BASE_PATH}/${taskId}/create-interval`);
    return api.post(url, data);
  },
  async updateTaskInterval(taskId, intervalId, data) {
    const url = mountUrl(`/${BASE_PATH}/${taskId}/update-interval/${intervalId}`);
    return api.patch(url, data);
  },
  async deleteTaskInterval(taskId, intervalId) {
    const url = mountUrl(`/${BASE_PATH}/${taskId}/delete-interval/${intervalId}`);
    return api.delete(url);
  },
  async getTaskLogs(taskId) {
    const url = mountUrl(`/${BASE_PATH}/${taskId}/get-logs`);
    return api.get(url);
  }
};
